import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BillItemsContext = createContext();

export const useBillItems = () => useContext(BillItemsContext);

export const BillItemsProvider = ({ children }) => {
  const location = useLocation();
  const { roomNo, registration, kotNo, id } = location.state || {};
  const customerId = localStorage.getItem("customerId");
  const [billItems, setBillItems] = useState([]);
  useEffect(() => {
    if (kotNo) {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            `https://api.hotel.launchlysoftware.in/api/getKotBillById/${customerId}/${id}`,
          );
          const kotData = response.data;
          setBillItems(kotData.foodItem);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [kotNo]);
  console.log(billItems, "billItems");

  const addToBill = (item) => {
    const existingItemIndex = billItems.findIndex(
      (billItem) => billItem._id === item._id,
    );

    if (existingItemIndex !== -1) {
      const newBillItems = [...billItems];
      newBillItems[existingItemIndex].quantity += 1;
      newBillItems[existingItemIndex].price =
        newBillItems[existingItemIndex].quantity *
        newBillItems[existingItemIndex].rate;
      setBillItems(newBillItems);
    } else {
      setBillItems([...billItems, { ...item, quantity: 1, price: item.rate }]);
    }
  };

  const updateQuantity = (index, quantity) => {
    if (quantity <= 0) {
      return;
    }
    const newBillItems = [...billItems];
    //console.log(typeof(quantity),newBillItems[index].price,'quantity')
    if (newBillItems[index].rate === undefined) {
      newBillItems[index].rate =
        newBillItems[index].price / newBillItems[index].quantity;
    }
    newBillItems[index].quantity = quantity;
    newBillItems[index].price = quantity * newBillItems[index].rate;
    console.log(newBillItems[index], "newBillItems");
    setBillItems(newBillItems);
  };

  const deleteItem = (index) => {
    const newBillItems = billItems.filter((_, i) => i !== index);
    setBillItems(newBillItems);
  };

  const clearBill = () => {
    setBillItems([]);
  };

  return (
    <BillItemsContext.Provider
      value={{
        billItems,
        addToBill,
        setBillItems,
        updateQuantity,
        deleteItem,
        clearBill,
      }}
    >
      {children}
    </BillItemsContext.Provider>
  );
};

export default BillItemsContext;
